module.exports = __webpack_public_path__ + "static/img/topic-rank-banner.1cc9de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topic-rank-banner.png
// module id = F5h8
// module chunks = 52